import * as InstrumentModelOnboardConfigConstants from "./InstrumentModelOnboardConfigConstants";
import * as CommonConstants from "Common/constants/commonConstants";
import { produce} from "immer";
import {
  STATUS_FAILURE,
  STATUS_SUCCESS,
} from "Common/constants/commonConstants";
// Object.assign is not yet fully supported in all browsers, so we fallback to a polyfill
const assign = Object.assign || require("object.assign");

const initialState = {
  modelStatus: CommonConstants.STATUS_SUCCESS,
  saveModel: CommonConstants.STATUS_SUCCESS,
  isFetchModel: CommonConstants.STATUS_SUCCESS,
  modelList: [],
  popupTitle: "",
  popupMessage: "",
  isPopupOpen: false,
  confirmTitle: "",
  confirmMessage: "",
  isOpenConfirmPopup: false,
  isModelSavedSuccessPopup: false,
  saveSuccessModelMessage: "",
  isModelSavedErrorPopup: false,
  saveErrorModelMessage: "",
  modelData: {},
  defaultOnboardIntrumentModel: {
    modelName: [],
    modelNameError: "",
    imageObj: {
      fileURL: null,
      imageSize: "",
      imageType: "",
      imageName: "",
      bj: null,
      error: "",
      isDatalakeURL: false,
    },
    whiteListingDir: [
      {
        dirAbsPath: "",
        dirLogicalName: "",
        error: "",
      },
    ],
    blackListingDir: [
      {
        dirAbsPath: "",
        fileName: "",
        error: "",
      },
    ],
    isBaseScriptSaved:false
  },
  onboardInstrumentJson: {
    modelName: [],
    modelNameError: "",
    imageObj: {
      fileURL: null,
      imageSize: "",
      imageType: "",
      imageName: "",
      obj: null,
      error: "",
      isDatalakeURL: false,
    },
    whiteListingDir: [
      {
        dirAbsPath: "",
        dirLogicalName: "",
        error: "",
      },
    ],
    blackListingDir: [
      {
        dirAbsPath: "",
        fileName: "",
        error: "",
      },
    ],
    isBaseScriptSaved:false
  },
  onLoadModelJson: {},
  directoryLimit:10,
  suggestions:[],
  possibleValues:[],
  isInputFocused:false,
  trackingList:[]
};

export default function InstrumentModelOnboardConfigReducer(
  state = initialState,
  action
) {
  switch (action.type) {
    case InstrumentModelOnboardConfigConstants.FETCH_MODEL_LIST_REQUEST: {
      const newState = {
        ...state,
        modelStatus: CommonConstants.STATUS_PENDING,
      };
      return assign({}, state, newState);
    }
    case InstrumentModelOnboardConfigConstants.FETCH_MODEL_LIST_SUCCESS: {
      const newState = {
        ...state,
        modelStatus: STATUS_SUCCESS,
        modelList: action.payload,
      };
      return assign({}, state, newState);
    }
    case InstrumentModelOnboardConfigConstants.FETCH_MODEL_LIST_ERROR: {
      const newState = {
        ...state,
        modelStatus: STATUS_FAILURE,
      };
      return assign({}, state, newState);
    }
    case InstrumentModelOnboardConfigConstants.ONBOARD_INSTRUMENT_JSON: {
      const newState = produce(state, (draftState) => {
        draftState.onboardInstrumentJson = {
          ...action.payload,
        };
      });
      return assign({}, state, newState);
    }
    case InstrumentModelOnboardConfigConstants.ON_MODEL_LOAD: {
      const newState = produce(state, (draftState) => {
        draftState.onboardInstrumentJson = {
          ...action.payload,
        };
      });
      return assign({}, state, newState);
    }

    case InstrumentModelOnboardConfigConstants.CLEAR_CONTENT: {
      const newState = {
        ...state,
        onboardInstrumentJson: action.payload,
      };
      return assign({}, state, newState);
    }
    case InstrumentModelOnboardConfigConstants.IMAGE_PREVIEW_POPUP_OPEN: {
      const newState = {
        ...state,
        previewTitle: action.payload.previewTitle,
        isPreviewImageOpen: action.payload.isPreviewImageOpen,
      };
      return assign({}, state, newState);
    }
    case InstrumentModelOnboardConfigConstants.IMAGE_PREVIEW_POPUP_CLOSE: {
      const newState = {
        ...state,
        isPreviewImageOpen: action.payload,
      };

      return assign({}, state, newState);
    }
    case InstrumentModelOnboardConfigConstants.SAVE_CONFIRM_POPUP_OPEN: {
      const newState = {
        ...state,
        confirmTitle: action.payload.title,
        confirmMessage: action.payload.message,
        isOpenConfirmPopup: action.payload.isOpen,
      };
      return assign({}, state, newState);
    }
    case InstrumentModelOnboardConfigConstants.SAVE_CONFIRM_POPUP_CLOSE: {
      const newState = {
        ...state,
        isOpenConfirmPopup: action.payload,
      };
      return assign({}, state, newState);
    }
    case InstrumentModelOnboardConfigConstants.CANCEL_CONFIRM_POPUP_OPEN: {
      const newState = {
        ...state,
        cancelConfirmTitle: action.payload.title,
        cancelConfirmMessage: action.payload.message,
        isOpenCancelConfirmPopup: action.payload.isOpen,
      };
      return assign({}, state, newState);
    }
    case InstrumentModelOnboardConfigConstants.CANCEL_CONFIRM_POPUP_CLOSE: {
      const newState = {
        ...state,
        isOpenCancelConfirmPopup: action.payload,
      };
      return assign({}, state, newState);
    }
    case InstrumentModelOnboardConfigConstants.INSTRUMENT_MODEL_REQUEST: {
      const newState = {
        ...state,
        saveModel: CommonConstants.STATUS_PENDING,
      };
      return assign({}, state, newState);
    }
    case InstrumentModelOnboardConfigConstants.INSTRUMENT_MODEL_SUCCESS: {
      const newState = {
        ...state,
        saveModel: STATUS_SUCCESS,
        isModelSavedSuccessPopup: true,
        isModelSavedErrorPopup: false,
        saveSuccessModelMessage: action.payload,
      };
      return assign({}, state, newState);
    }
    case InstrumentModelOnboardConfigConstants.INSTRUMENT_MODEL_ERROR: {
      const newState = {
        ...state,
        saveModel: STATUS_FAILURE,
        isModelSavedSuccessPopup: false,
        isModelSavedErrorPopup: true,
        saveErrorModelMessage: action.payload,
      };
      return assign({}, state, newState);
    }

    case InstrumentModelOnboardConfigConstants.CLOSE_SUCCESS_MESSAGE_POPUP:
      return assign({}, state, {
        isModelSavedSuccessPopup: false,
      });
    case InstrumentModelOnboardConfigConstants.CLOSE_ERROR_MESSAGE_POPUP:
      return assign({}, state, {
        isModelSavedErrorPopup: false,
      });
    case InstrumentModelOnboardConfigConstants.FETCH_MODEL_DATA_REQUEST: {
      const newState = {
        ...state,
        isFetchModel: CommonConstants.STATUS_PENDING,
      };
      return assign({}, state, newState);
    }
    case InstrumentModelOnboardConfigConstants.FETCH_MODEL_DATA_SUCCESS: {
      const newState = {
        ...state,
        isFetchModel: STATUS_SUCCESS,
        modelData: action.payload,
      };
      return assign({}, state, newState);
    }
    case InstrumentModelOnboardConfigConstants.FETCH_MODEL_DATA_ERROR: {
      const newState = {
        ...state,
        isFetchModel: STATUS_FAILURE,
        isModelSavedErrorPopup: true,
        saveErrorModelMessage: action.payload,
      };
      return assign({}, state, newState);
    }
    case InstrumentModelOnboardConfigConstants.FETCH_INSTRUMENT_CONFIG:{
      const newState = {
        ...state,
        directoryLimit: action.payload.directoryLimit,
      };
      return assign({}, state, newState);
    }
    case InstrumentModelOnboardConfigConstants.ELEMENT_FOCUS: {
      const newState = {
        ...state,
        isInputFocused: action.payload,
      };
      return assign({}, state, newState);
    }
    case InstrumentModelOnboardConfigConstants.FILTERED_AUTOCOMPLETE_VALUES: {
      const newState = {
        ...state,
        suggestions: action.payload,
      };
      return assign({}, state, newState);
    }
    case InstrumentModelOnboardConfigConstants.ADD_SUGGESTIONS: {
      const newState = {
        ...state,
        possibleValues: action.payload,
      };
      return assign({}, state, newState);
    }
    case InstrumentModelOnboardConfigConstants.TRACKING: {
      const newState = {
        ...state,
        trackingList: action.payload,
      };
      return assign({}, state, newState);
    }
    
    default:
      return state;
  }
}
